<div class="progress-bar" #progressBar [ngStyle]="{ width: progressWidth}"></div>
